import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { connect } from "react-redux";

import { Alert } from "reactstrap";
import { Row, Col, FormGroup } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  Chip,
  TextField,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import { Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import accessToken from "../../../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import {
  getOrgAccounts,
  clearAllOrgAcctMessages,
} from "../../../store/orgAcct/actions";

import {
  getOrganizationIaac,
  postOrganizationIaac,
  putOrganizationIaac,
  clearAllOrganizationIaacMessages,
  getGlobalIaac,
  clearAllGlobalIaacMessages,
  deleteOrganizationIaac,
} from "../../../store/actions";

import spinner from "../../../assets/images/loadingGif.gif";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const OrganizationIaac = (props) => {
  console.log("OrganizationIaac props: ", props);
  const getOrganizationIaac = useCallback(props.getOrganizationIaac, []);
  const getGlobalIaac = useCallback(props.getGlobalIaac, []);
  const clearAllOrganizationIaacMessages = useCallback(
    props.clearAllOrganizationIaacMessages,
    []
  );
  const clearAllGlobalIaacMessages = useCallback(
    props.clearAllGlobalIaacMessages,
    []
  );
  const clearAllOrgAcctMessages = useCallback(
    props.clearAllOrgAcctMessages,
    []
  );
  const getOrgAccounts = useCallback(props.getOrgAccounts, []);

  const [customLicenseName, setCustomLicenseName] = useState("");
  const [customPrice, setCustomPrice] = useState("");
  const [customLimit, setCustomLimit] = useState("");

  const [editCustomLicenseName, setEditCustomLicenseName] = useState("");
  const [editCustomPrice, setEditCustomPrice] = useState("");
  const [editCustomLimit, setEditCustomLimit] = useState("");
  const [customSubscription, setCustomSubscription] = useState(null);

  const [orgIaacSubscription, setOrgIaacSubscription] = useState(null);

  const { orgCode } = useParams();
  const appBarStyles = {
    backgroundColor: "whitesmoke",
    // Add more custom styles as needed
  };
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const classes = useStyles();

  useEffect(() => {
    if (props.organization === null) {
      getOrgAccounts(orgCode);
    }
  }, [getOrgAccounts, props.organization, orgCode]);

  //For displaying message for getting organization account
  let getOrgAccountsMsg = props.getOrgAccountsMessage;
  let getOrgAccountsErr = props.getOrgAccountsError;
  useEffect(() => {
    console.log("getOrgAccountsMsg = " + getOrgAccountsMsg);
    if (getOrgAccountsMsg || getOrgAccountsErr) {
      console.log("Inside if, getOrgAccountsMsg = " + getOrgAccountsMsg);
      setTimeout(() => {
        clearAllOrgAcctMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getOrgAccountsMsg, getOrgAccountsErr, clearAllOrgAcctMessages]);

  // Get organization iaac information
  useEffect(() => {
    console.log("~~~~~useEffect for getting iaac information");
    if (props.iaac === null) {
      console.log("~~~~~props.iaac===null");
      getOrganizationIaac(orgCode);
    }
  }, [props.iaac, getOrganizationIaac, orgCode]);

  // Get organization global iaac information
  useEffect(() => {
    console.log("~~~~~useEffect for getting iaac information");
    if (props.globalIaac === null || props.globalIaac === undefined) {
      getGlobalIaac(orgCode);
    }
  }, [props.globalIaac, getGlobalIaac, orgCode]);

  //For displaying message for getting organization iaac
  let getOrganizationIaacMsg = props.getOrganizationIaacMessage;
  let getOrganizationIaacErr = props.getOrganizationIaacError;
  useEffect(() => {
    console.log("getOrganizationIaacMsg = " + getOrganizationIaacMsg);
    if (getOrganizationIaacMsg || getOrganizationIaacErr) {
      console.log(
        "Inside if, getOrganizationIaacMsg = " + getOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    getOrganizationIaacMsg,
    getOrganizationIaacErr,
    clearAllOrganizationIaacMessages,
  ]);

  const getAndSetCustomSubscriptionState = useCallback(() => {
    if (props.globalIaac !== null && props.globalIaac !== undefined) {
      const { subscriptions } = props.globalIaac;
      // Filter out custom subscriptions
      const customSubscription = subscriptions.filter(
        (sub) => !["Basic", "Standard", "Premium"].includes(sub.subscription)
      );
      console.log(
        "getAndSetCustomSubscriptionState, customSubscription:",
        customSubscription
      );
      if (customSubscription) {
        setEditCustomLicenseName(customSubscription[0].subscription);
        setEditCustomPrice(customSubscription[0].price);
        setEditCustomLimit(customSubscription[0].limit);
        setCustomSubscription(customSubscription[0]);
      }
    }
  }, [props.globalIaac]);

  //For displaying message for getting global iaac
  let getGlobalIaacMsg = props.getGlobalIaacMessage;
  let getGlobalIaacErr = props.getGlobalIaacError;
  useEffect(() => {
    // If global iaac is retrieved, store it in state
    if (getGlobalIaacMsg) {
      getAndSetCustomSubscriptionState();
    }
    console.log("getGlobalIaacMsg = " + getGlobalIaacMsg);
    if (getGlobalIaacMsg || getGlobalIaacErr) {
      console.log("Inside if, getGlobalIaacMsg = " + getGlobalIaacMsg);
      setTimeout(() => {
        clearAllGlobalIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    getGlobalIaacMsg,
    getGlobalIaacErr,
    clearAllGlobalIaacMessages,
    getAndSetCustomSubscriptionState,
  ]);

  const showCreateCustomOrganizationIaac = () => {
    document.getElementById("createCustomOrgIaacId").style.display = "block";
    document.getElementById("editCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "none";
    document.getElementById("editOrganizationIaacId").style.display = "none";
  };

  const showEditCustomOrganizationIaac = () => {
    document.getElementById("editCustomOrgIaacId").style.display = "block";
    document.getElementById("createCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "none";
    document.getElementById("editOrganizationIaacId").style.display = "none";
  };

  const showEditOrganizationIaac = () => {
    console.log("showEditOrganizationIaac called");
    document.getElementById("editCustomOrgIaacId").style.display = "none";
    document.getElementById("createCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "none";
    document.getElementById("editOrganizationIaacId").style.display = "block";
    // Get Iaac for this organization from Global
    getOrganizationIaacFromGlobal();
  };

  const showOrganizationIaac = () => {
    document.getElementById("editCustomOrgIaacId").style.display = "none";
    document.getElementById("createCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "block";
    document.getElementById("editOrganizationIaacId").style.display = "none";
  };

  const isCustomLicensePresent = () => {
    if (props.globalIaac !== null && props.globalIaac !== undefined) {
      const { subscriptions } = props.globalIaac;
      const customSubscription = subscriptions.some(
        (sub) => !["Basic", "Standard", "Premium"].includes(sub.subscription)
      );
      // console.log("In isCustomLicensePresent, customSubscription : ", customSubscription)
      return customSubscription;
    }
    return false;
  };

  const handleCreateOrganizationIaac = () => {
    const iaacRequest = {
      subscription: customLicenseName,
      price: customPrice,
      limit: customLimit,
    };
    console.log("handleCreateOrganizationIaac, iaacRequest: ", iaacRequest);
    props.postOrganizationIaac(orgCode, iaacRequest);
  };

  //For displaying message for creating organization iaac
  let postOrganizationIaacMsg = props.createOrganizationIaacMessage;
  let postOrganizationIaacErr = props.createOrganizationIaacError;
  useEffect(() => {
    console.log("postOrganizationIaacMsg = " + postOrganizationIaacMsg);
    if (postOrganizationIaacMsg) {
      getGlobalIaac(orgCode);
    }
    if (postOrganizationIaacMsg || postOrganizationIaacErr) {
      console.log(
        "Inside if, postOrganizationIaacMsg = " + postOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    postOrganizationIaacMsg,
    postOrganizationIaacErr,
    getGlobalIaac,
    orgCode,
    clearAllOrganizationIaacMessages,
  ]);

  const handleOrgIaacSubscriptionChange = (e) => {
    console.log("e.target.value = " + e.target.value);
    if (e.target.value === "Select Subscription") {
      setOrgIaacSubscription(null);
    } else {
      setOrgIaacSubscription(e.target.value);
    }
  };

  const handleUpdateOrgIaacSubscription = () => {
    const orgIaacRequest = {
      subscription: orgIaacSubscription,
      limit_value: "00",
      price: "200",
    };
    console.log("Submitting for update, orgIaacRequest = ", orgIaacRequest);
    props.putOrganizationIaac(orgCode, orgIaacRequest, true);
  };

  const handleUpdateCustomOrganizationIaac = () => {
    const orgIaacRequest = {
      subscription: editCustomLicenseName,
      limit_value: editCustomLimit,
      price: editCustomPrice,
    };
    console.log(
      "Submitting for update custom license, orgIaacRequest = ",
      orgIaacRequest
    );
    props.putOrganizationIaac(orgCode, orgIaacRequest, false);
  };

  const handleDeleteOrgIaacSubscription = () => {
    console.log("handleDeleteOrgIaacSubscription: ");
    props.deleteOrganizationIaac(orgCode);
  };

  //For displaying message for updating organization iaac
  let putOrganizationIaacMsg = props.updateOrganizationIaacMessage;
  let putOrganizationIaacErr = props.updateOrganizationIaacError;
  useEffect(() => {
    console.log("putOrganizationIaacMsg = " + putOrganizationIaacMsg);
    if (putOrganizationIaacMsg) {
      getGlobalIaac(orgCode);
      getOrganizationIaac(orgCode);
    }
    if (putOrganizationIaacMsg || putOrganizationIaacErr) {
      setOrgIaacSubscription(null);
      console.log(
        "Inside if, putOrganizationIaacMsg = " + putOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    putOrganizationIaacMsg,
    putOrganizationIaacErr,
    getGlobalIaac,
    getOrganizationIaac,
    clearAllOrganizationIaacMessages,
    orgCode,
  ]);

  const getOrganizationIaacFromGlobal = () => {
    if (props.globalIaac === null || props.globalIaac === undefined) {
      props.getGlobalIaac(orgCode);
    }
  };

  //For displaying message for deleting organization iaac
  let delOrganizationIaacMsg = props.deleteOrganizationIaacMessage;
  let delOrganizationIaacErr = props.deleteOrganizationIaacError;
  useEffect(() => {
    console.log("delOrganizationIaacMsg = " + delOrganizationIaacMsg);
    if (delOrganizationIaacMsg) {
      getOrganizationIaac(orgCode);
    }
    if (delOrganizationIaacMsg || delOrganizationIaacErr) {
      // setOrgIaacSubscription(null);
      console.log(
        "Inside if, delOrganizationIaacMsg = " + delOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    delOrganizationIaacMsg,
    delOrganizationIaacErr,
    clearAllOrganizationIaacMessages,
    getOrganizationIaac,
    orgCode,
  ]);

  // let customOrgIaacSubscription = null;
  // if (props.globalIaac !== null && props.globalIaac !== undefined) {
  //   const { subscriptions } = props.globalIaac;
  //   // Filter out custom subscriptions
  //   const customOrgIaacSubscription = subscriptions.filter(sub => !["Basic", "Standard", "Premium"].includes(sub.subscription))[0];
  //   console.log("customOrgIaacSubscription:", customOrgIaacSubscription)
  // }

  return (
    <div>
      <AppBar position="static" style={appBarStyles}>
        <Toolbar>
          <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
            <Link component={RouterLink} to="/organization" color="inherit">
              <HomeOutlinedIcon />
            </Link>
            <Typography color="textPrimary">
              <Link component={RouterLink} to="/organization" color="inherit">
                Organization{" "}
              </Link>
              /
              <Link
                component={RouterLink}
                to="#"
                color="inherit"
                onClick={showOrganizationIaac}
              >
                {" "}
                IaaC{" "}
              </Link>
              {/* <span id="viewId">IaaC</span> */}
            </Typography>
            {props?.organization?.orgname && (
              <Chip label={props?.organization?.orgname} color="primary" />
            )}
          </Breadcrumbs>
          <div>
            <Button
              onClick={showCreateCustomOrganizationIaac}
              style={{ color: "blue", padding: "1rem" }}
              disabled={isCustomLicensePresent()}
            >
              Create Custom License
            </Button>
            <Button
              onClick={showEditCustomOrganizationIaac}
              style={{ color: "blue", padding: "1rem" }}
              disabled={!isCustomLicensePresent()}
            >
              Edit Custom License
            </Button>
            <Button
              onClick={showEditOrganizationIaac}
              style={{ color: "blue", padding: "1rem" }}
            >
              Edit License
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      <div id="organizationIaacId">
        {(props.isGettingOrgAccounts ||
          props.isGettingOrganizationIaac ||
          props.isGettingGlobalIaac ||
          props.isDeletingOrganizationIaac) && (
          <div
            style={{
              display: "flex",
              direction: "column",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              height: "100vh",
            }}
          >
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <h1>Organization IaaC</h1>
          {props.deleteOrganizationIaacMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.deleteOrganizationIaacMessage}
            </Alert>
          )}
          {props.deleteOrganizationIaacError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while deleting organization IaaC.
              {JSON.stringify(props.deleteOrganizationIaacError)}
            </Alert>
          )}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                m: 1,
                width: 250,
                height: 250,
                padding: "20px",
              },
            }}
          >
            {props.iaac && (
              <Paper key={props.iaac.subscription} elevation={3}>
                <Stack spacing={2}>
                  <h3>{props.iaac.subscription}</h3>
                  <h4>${props.iaac.price}</h4>
                  <Divider light />
                  <div>
                    <CheckCircleIcon />
                    Upload Limit {props.iaac.limit}
                  </div>
                  <FormControl>
                    <Button
                      variant="contained"
                      disabled={props.isDeletingOrganizationIaac}
                      onClick={() => handleDeleteOrgIaacSubscription()}
                    >
                      Delete
                    </Button>
                  </FormControl>
                </Stack>
              </Paper>
            )}
            {customSubscription && (
              <Paper key={customSubscription.subscription} elevation={3}>
                <Stack spacing={2}>
                  <h3>{customSubscription.subscription}</h3>
                  <h4>${customSubscription.price}</h4>
                  <Divider light />
                  <div>
                    <CheckCircleIcon />
                    Upload Limit {customSubscription.limit}
                  </div>
                  {/* <FormControl>
                      <Button
                        variant="contained"
                        disabled={props.isDeletingOrganizationIaac}
                        onClick={() => handleDeleteOrgIaacSubscription(customOrgIaacSubscription)}
                      >
                        Delete
                      </Button>
                    </FormControl> */}
                </Stack>
              </Paper>
            )}
          </Box>
        </div>
      </div>

      {/* Create Custom Iaac */}
      <div id="createCustomOrgIaacId" style={{ display: "none" }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1>Create Custom Organization IaaC</h1>
          {props.createOrganizationIaacMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.createOrganizationIaacMessage}
            </Alert>
          )}
          {props.createOrganizationIaacError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while creating custom subscription.
              {JSON.stringify(props.createOrganizationIaacError)}
            </Alert>
          )}
          <table>
            <thead>
              <tr>
                <th>Parameter Name</th>
                <th>Parameter Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Custom License Name</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="text"
                    value={customLicenseName}
                    onChange={(e) => setCustomLicenseName(e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>Price</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={customPrice}
                    onChange={(e) => setCustomPrice(parseInt(e.target.value))}
                  />
                </td>
              </tr>
              <tr>
                <td>Limit</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={customLimit}
                    onChange={(e) => setCustomLimit(parseInt(e.target.value))}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={props.isCreatingOrganizationIaac}
                    onClick={handleCreateOrganizationIaac}
                  >
                    Create
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Custom Iaac */}
      <div id="editCustomOrgIaacId" style={{ display: "none" }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1>Edit Custom Organization IaaC</h1>
          {props.updateOrganizationIaacMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.updateOrganizationIaacMessage}
            </Alert>
          )}
          {props.updateOrganizationIaacError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while updating organization IaaC.
              {JSON.stringify(props.updateOrganizationIaacError)}
            </Alert>
          )}
          <table>
            <thead>
              <tr>
                <th>Parameter Name</th>
                <th>Parameter Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Custom License Name</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="text"
                    value={editCustomLicenseName}
                    disabled={true}
                    // onChange={(e) => setCustomLicenseName(e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td>Price</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={editCustomPrice}
                    onChange={(e) =>
                      setEditCustomPrice(parseInt(e.target.value))
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Limit</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={editCustomLimit}
                    onChange={(e) =>
                      setEditCustomLimit(parseInt(e.target.value))
                    }
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={props.isUpdatingOrganizationIaac}
                    onClick={handleUpdateCustomOrganizationIaac}
                  >
                    Update
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Organization Iaac */}
      <div id="editOrganizationIaacId" style={{ display: "none" }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1>Edit Organization IaaC</h1>
          {props.updateOrganizationIaacMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.updateOrganizationIaacMessage}
            </Alert>
          )}
          {props.updateOrganizationIaacError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while updating organization IaaC.
              {JSON.stringify(props.updateOrganizationIaacError)}
            </Alert>
          )}
          {props.globalIaac === null || props.globalIaac === undefined ? (
            <div
              style={{
                display: "flex",
                direction: "column",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                justifyItems: "center",
                height: "100vh",
              }}
            >
              <img src={spinner} width="32px" alt="Spinner" />
            </div>
          ) : (
            <AvForm className="form-horizontal">
              <Row>
                <Col lg="12">
                  <FormGroup>
                    <AvField
                      type="select"
                      name="subscription"
                      className={"form-control"}
                      // value={subscription}
                      onChange={handleOrgIaacSubscriptionChange}
                    >
                      <option key="select">Select Subscription</option>
                      {props.globalIaac["subscriptions"].map(
                        (subscriptionItem) => (
                          <option key={subscriptionItem.subscription}>
                            {subscriptionItem.subscription}
                          </option>
                        )
                      )}
                    </AvField>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="12">
                  <FormGroup>
                    <Button
                      color="primary"
                      variant="contained"
                      className="w-md waves-effect waves-light"
                      type="submit"
                      disabled={
                        orgIaacSubscription === null ||
                        props.isUpdatingOrganizationIaac
                      }
                      onClick={handleUpdateOrgIaacSubscription}
                    >
                      Update Subscription
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </AvForm>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,
  } = state.orgAccount;

  const {
    iaac,

    isGettingOrganizationIaac,
    getOrganizationIaacMessage,
    getOrganizationIaacError,

    isCreatingOrganizationIaac,
    createOrganizationIaacMessage,
    createOrganizationIaacError,

    isUpdatingOrganizationIaac,
    updateOrganizationIaacMessage,
    updateOrganizationIaacError,

    isDeletingOrganizationIaac,
    deleteOrganizationIaacMessage,
    deleteOrganizationIaacError,
  } = state.organizationIaac;

  const {
    iaac: globalIaac,
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
  } = state.globalIaac;

  return {
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

    iaac,

    isGettingOrganizationIaac,
    getOrganizationIaacMessage,
    getOrganizationIaacError,

    isCreatingOrganizationIaac,
    createOrganizationIaacMessage,
    createOrganizationIaacError,

    isUpdatingOrganizationIaac,
    updateOrganizationIaacMessage,
    updateOrganizationIaacError,

    isDeletingOrganizationIaac,
    deleteOrganizationIaacMessage,
    deleteOrganizationIaacError,

    globalIaac,
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
    clearAllOrgAcctMessages: () => {
      dispatch(clearAllOrgAcctMessages());
    },
    getOrganizationIaac: (orgCode) => {
      // console.log("before dispatch getOrganizationIaac")
      dispatch(getOrganizationIaac(orgCode));
    },
    postOrganizationIaac: (orgCode, iaacRequest) => {
      dispatch(postOrganizationIaac(orgCode, iaacRequest));
    },
    putOrganizationIaac: (orgCode, iaacRequest, subscriptionChange) => {
      dispatch(putOrganizationIaac(orgCode, iaacRequest, subscriptionChange));
    },
    deleteOrganizationIaac: (orgCode, iaacRequest) => {
      dispatch(deleteOrganizationIaac(orgCode, iaacRequest));
    },
    clearAllOrganizationIaacMessages: () => {
      dispatch(clearAllOrganizationIaacMessages());
    },
    getGlobalIaac: (orgCode) => {
      dispatch(getGlobalIaac(orgCode));
    },
    clearAllGlobalIaacMessages: () => {
      dispatch(clearAllGlobalIaacMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationIaac);
